import { getLocalStorage } from 'utils';

export const gdpService = '/gdp';

export const getLocale = (): string => getLocalStorage('locale') ?? 'en';
